import {
  Box,
  Button,
  CircularProgress,
  Grid,
  TextField,
  Typography
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Container } from "shards-react";
import ReusableModal from "../components/components-overview/Model";
import ReusableDialog from "../components/components-overview/DialogBox";
import axios from "axios";
import ControlledDialog from "../components/components-overview/DialogBox";
import SmallStats from "../components/common/SmallStats";
import SoilTestTable from "../components/components-overview/GetAllSoilData";
const SoilTesting = () => {
  const [openModal, setOpenModal] = useState(false);
  const [openDialog, setOpenDialog] = useState({
    probePlacement: false,
    AbortTimer: false
  });
  const [timeLeft, setTimeLeft] = useState(null);
  const [testing, setTesting] = useState({
    soiltype: null,
    coordinatesX: null,
    coordinatesY: null,
    depthinput: null,
    abortReason: null
  });
  const [finalData, setfinalData] = useState({
    temp: 0,
    Humidity: 0,
    conductivity: 0,
    ph: 0,
    nitrogen: 0,
    phosphorus: 0,
    pottasium: 0
  });
  const [currTest, setCurrTest] = useState({
    test_id: null,
    test_status: null,
    probe_placed: null,
    placement_validated: null,
    current_step: 1,
    timer_started_at: null,
    retry: false,
    retryMessage: "There was an unexpected error. Please try again."
  });
  const [token , setToken] = useState("")
  const [loading, setLoading] = useState({
    step1: false,
    step2: false,
    step3: false,
    abort: false
  });
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const handleTesting = (event, name) => {
    event.persist();
    setTesting(prev => ({
      ...prev,
      [name]: event.target.value
    }));
  };
  const fileInputRef = useRef(null);
  const handleFileUpload = event => {
    const files = Array.from(event.target.files);
    console.log(files, 68);

    setUploadedFiles(prevFiles => [...prevFiles, ...files]);
  };

  useEffect(() => {
    if (timeLeft == 0) {
      let a = {};
      const fetchApiData = async () => {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_BASE_URL}/agri/latest/data`
          );
          const apiData = await response.json();
          a = apiData.data[0];

          setfinalData({
            temp: a.temperature,
            Humidity: a.humidity,
            conductivity: a.conductivity,
            ph: a.ph,
            nitrogen: a.nitrogen,
            phosphorus: a.phosphorus,
            pottasium: a.potassium
          });
          const formData = new FormData();
          formData.append("n", a.nitrogen);
          formData.append("p", a.phosphorus);
          formData.append("k", a.potassium);
          formData.append("moisture_percent", a.humidity);
          formData.append("temperature_c", a.temperature);
          formData.append("electrical_conductivity", a.conductivity);
          formData.append("ph", a.ph);
          formData.append("remarks", "Test completed successfully");

          if (uploadedFiles.length > 0) {
            formData.append("image", uploadedFiles[0]); 
          }

          const secondResponse = await axios.put(
            `${process.env.REACT_APP_BASE_URL}/api/v1/soil_test/${currTest.test_id}/results`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            }
          );

          if (secondResponse.data.status == "completed") {
            setCurrTest(prev => ({
              ...prev,
              test_status: secondResponse.data.test_status
            }));
          }
        } catch (error) {
          console.log("Error fetching API data:", error);
        }
      };
      fetchApiData();
    }
  }, [timeLeft]);

  const smallStat = [
    {
      label: "Nitrogen ",

      value: [Number(finalData.nitrogen)],
      percentage: "2.4% ",
      units: "mg/kg",
      img: "/Nitrogen.svg",
      increase: false,
      decrease: true,
      chartLabels: [null, null, null, null, null, null, null],
      attrs: { md: "4", sm: "6" },
      datasets: [
        {
          label: "Today",
          fill: "start",
          borderWidth: 1.5,
          backgroundColor: "rgb(0,123,255,0.1)",
          borderColor: "rgb(0,123,255)",
          data: [3, 2, 3, 2, 4, 5, 4]
        }
      ]
    },
    {
      label: "Phosphorus",
      value: [Number(finalData.phosphorus)],
      percentage: "12.4",
      img: "/Phosphorus.svg",
      increase: true,
      units: "mg/kg",
      chartLabels: [null, null, null, null, null, null, null],
      attrs: { md: "6", sm: "6" },
      style: { fontSize: "12px" },
      datasets: [
        {
          label: "Today",
          fill: "start",
          borderWidth: 1.5,
          backgroundColor: "rgba(23,198,113,0.1)",
          borderColor: "rgb(23,198,113)",
          data: [1, 2, 3, 3, 3, 4, 4]
        }
      ]
    },
    {
      label: "Potassium",
      value: [Number(finalData.pottasium)],
      percentage: "12.4",
      img: "/Potassium.svg",
      increase: true,
      units: "mg/kg",
      chartLabels: [null, null, null, null, null, null, null],
      attrs: { md: "6", sm: "6" },
      style: { fontSize: "12px" },
      datasets: [
        {
          label: "Today",
          fill: "start",
          borderWidth: 1.5,
          backgroundColor: "rgba(23,198,113,0.1)",
          borderColor: "rgb(23,198,113)",
          data: [1, 2, 3, 3, 3, 4, 4]
        }
      ]
    },
    {
      label: "Temperature",
      value: [Number(finalData.temp)],
      percentage: "4.7%",
      img: "/Temperature.svg",
      units: "°C",
      increase: true,
      chartLabels: [null, null, null, null, null, null, null],
      attrs: { md: "6", sm: "6" },
      datasets: [
        {
          label: "Today",
          fill: "start",
          borderWidth: 1.5,
          backgroundColor: "rgba(0, 184, 216, 0.1)",
          borderColor: "rgb(0, 184, 216)",
          data: [1, 2, 1, 3, 5, 4, 7]
        }
      ]
    },
    {
      label: "Moisture",
      value: [Number(finalData.Humidity)],
      percentage: "12.4",
      img: "/Humidity.svg",
      increase: true,
      units: "%RH",
      chartLabels: [null, null, null, null, null, null, null],
      attrs: { md: "6", sm: "6" },
      datasets: [
        {
          label: "Today",
          fill: "start",
          borderWidth: 1.5,
          backgroundColor: "rgba(23,198,113,0.1)",
          borderColor: "rgb(23,198,113)",
          data: [1, 2, 3, 3, 3, 4, 4]
        }
      ]
    },
    {
      label: "Conductivity",
      value: [Number(finalData.conductivity)],
      percentage: "3.8%",
      increase: false,
      img: "/Conductivity.svg",
      decrease: true,
      units: "us/cm",
      chartLabels: [null, null, null, null, null, null, null],
      attrs: { md: "4", sm: "6" },
      datasets: [
        {
          label: "Today",
          fill: "start",
          borderWidth: 1.5,
          backgroundColor: "rgba(255,180,0,0.1)",
          borderColor: "rgb(255,180,0)",
          data: [2, 3, 3, 3, 4, 3, 3]
        }
      ]
    },
    {
      label: "pH",
      value: [Number(finalData.ph)],
      percentage: "2.71%",
      increase: false,
      img: "/pH.svg",
      decrease: true,
      units: "pH",
      chartLabels: [null, null, null, null, null, null, null],
      attrs: { md: "4", sm: "6" },
      datasets: [
        {
          label: "Today",
          fill: "start",
          borderWidth: 1.5,
          backgroundColor: "rgba(255,65,105,0.1)",
          borderColor: "rgb(255,65,105)",
          data: [1, 7, 1, 3, 1, 4, 8]
        }
      ]
    }
  ];

  const handleStartNewTest = () => {
    setOpenDialog({
      probePlacement: false,
      AbortTimer: false
    });
    setTimeLeft(null);
    setTesting({
      soiltype: null,
      coordinatesX: null,
      coordinatesY: null,
      depthinput: null,
      abortReason: null
    });
    setfinalData({
      temp: 0,
      Humidity: 0,
      conductivity: 0,
      ph: 0,
      nitrogen: 0,
      phosphorus: 0,
      pottasium: 0
    });
    setCurrTest({
      test_id: null,
      test_status: null,
      probe_placed: null,
      placement_validated: null,
      current_step: 1,
      timer_started_at: null,
      retry: false
    });
    setLoading({
      step1: false,
      step2: false,
      step3: false,
      abort: false
    });
    setUploadedFiles([]);
  };

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        position => {
          setTesting(prev => ({
            ...prev,
            coordinatesX: position.coords.latitude.toFixed(6),
            coordinatesY: position.coords.longitude.toFixed(6)
          }));
        },
        err => {
          console.error("Error fetching location:", err);
        }
      );
    } else {
      console.log("error");
    }
  }, [openModal]);

  function isTimestampWithinLastTwoMinutes(rawTimestamp) {
    // Clean timestamp string
    let cleaned = rawTimestamp
      .replace(" ", "T") // " " → "T"
      .replace(/\.\d+/, "") // remove microseconds (e.g. .816871)
      .replace(/([+-]\d{2})(\d{2})$/, "$1:$2"); // +0530 → +05:30

    const dataTime = new Date(cleaned);
    // Subtract 5 hours and 30 minutes (in milliseconds)
    const offsetMs = (5 * 60 + 30) * 60 * 1000;
    const newDate = new Date(dataTime.getTime() - offsetMs);

    const now = new Date();
    const diffMs = now - newDate;

    const diffMinutes = diffMs / 1000 / 60;

    return diffMinutes <= 2;
  }

  useEffect(() => {
    if (currTest.timer_started_at) {
      const trimmedTime = currTest.timer_started_at.slice(0, 23);
      const utcTime = new Date(trimmedTime + "Z");
      const istTime = new Date(utcTime.getTime());

      // const endTime = new Date(istTime.getTime() + 5 * 60 * 1000);
      const endTime = new Date(istTime.getTime() + 10 * 60 * 1000);

      let countdownTimer;
      let pollingTimer;

      const stopTimers = () => {
        clearInterval(countdownTimer);
        clearInterval(pollingTimer);
      };

      const updateTimer = () => {
        const now = new Date();
        const diff = endTime - now;

        if (diff <= 0) {
          setTimeLeft(0);
          stopTimers();
        } else {
          setTimeLeft(diff);
        }
      };

      const pollApi = async () => {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_BASE_URL}/agri/latest/data`
          );

          const data = response.data.data[0];

          if (!data) {
            console.warn("No data in response");
            stopTimers();
            return;
          }

          const {
            humidity,
            temperature,
            conductivity,
            ph,
            nitrogen,
            potassium,
            phosphorus,
            timestamp
          } = data;

          // console.log(currTest.timer_started_at, 466);

          // const dataTime = new Date(currTest.timer_started_at);
          // const startTime = new Date(timestamp);

          // // Create offset in milliseconds for 5 hours 30 minutes
          // const IST_OFFSET_MS = 5.5 * 60 * 60 * 1000;

          // // Adjust times manually
          // const adjustedDataTime = new Date(dataTime.getTime() + IST_OFFSET_MS);
          // const adjustedStartTime = new Date(startTime.getTime() - IST_OFFSET_MS);
          //   console.log(adjustedDataTime, adjustedStartTime, 468);

          //    if (adjustedDataTime <= adjustedStartTime) {
          //         setCurrTest(prev => ({ ...prev, retry: true, retryMessage: "Awaiting recent data from the device. Please ensure it's online." }));

          //    }

          // Example

          if (!isTimestampWithinLastTwoMinutes(timestamp)) {
            console.log("Timestamp is older than 5 minutes");
            stopTimers(); // or your fallback logic
            setCurrTest(prev => ({
              ...prev,
              retry: true,
              retryMessage: "Device is offline"
            }));
            return;
          }

          const criticalParams = {
            humidity,
            temperature,
            conductivity,
            ph,
            nitrogen,
            potassium,
            phosphorus
          };

          const zeroFields = Object.entries(criticalParams).filter(
            ([_, value]) => Number(value) === 0
          );

          if (zeroFields.length > 0) {
            stopTimers();

            setCurrTest(prev => ({
              ...prev,
              retry: true,
              retryMessage: "There was an unexpected error. Please try again."
            }));
            return;
          }
        } catch (error) {
          stopTimers();

          setCurrTest(prev => ({
            ...prev,
            true: true,
            retryMessage: "There was an unexpected error. Please try again."
          }));
          console.error("API call failed:", error.message);
        }
      };

      // Initial calls
      updateTimer();
      pollApi();

      countdownTimer = setInterval(updateTimer, 1000); // 1s
      pollingTimer = setInterval(pollApi, 5000); // 5s

      return () => stopTimers();
    }
  }, [currTest.timer_started_at]);




  const formatTime = ms => {
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  };

  const handleProceedStartTest = async e => {
    try {
      setLoading(prev => ({ ...prev, step3: true }));

      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/api/v1/soil_test/${currTest.test_id}/confirm`,
        {
          test_confirmed: currTest.placement_validated
        }
      );

      if (response.data.status == "timer_started") {
        setCurrTest(prev => ({
          ...prev,
          test_status: response.data.test_status,
          timer_started_at: response.data.timer_started_at,
          retry: false
        }));
      }
    } catch (error) {
      console.error("Error uploading:", error);
    } finally {
      setLoading(prev => ({ ...prev, step3: false }));
    }
  };

  const handleAbortTimer = async e => {
    try {
      setLoading(prev => ({ ...prev, abort: true }));

      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/api/v1/soil_test/${currTest.test_id}/abort`,
        {
          reason: testing.abortReason
        }
      );

      if (response.data.status == "aborted") {
        setTimeLeft(null);
        setTesting({
          soiltype: null,
          coordinatesX: null,
          coordinatesY: null,
          depthinput: null,
          abortReason: null
        });
        setCurrTest({
          test_id: null,
          test_status: null,
          probe_placed: null,
          placement_validated: null,
          current_step: 1,
          timer_started_at: null
        });
        setLoading({
          step1: false,
          step2: false,
          step3: false,
          abort: false
        });
        setOpenDialog(prev => ({ ...prev, AbortTimer: false }));
      }
    } catch (error) {
      console.error("Error uploading:", error);
    } finally {
      setLoading(prev => ({ ...prev, abort: false }));
    }
  };

  const handleProceedTest = async e => {
    // const formData = new FormData();
    // formData.append("soiltype", testing.soiltype);
    // formData.append("depthinput", testing.depthinput);
    // formData.append("coordinatesX", testing.coordinatesX);
    // formData.append("coordinatesY", testing.coordinatesY);

    // // Attach all uploaded files
    // if (uploadedFiles && uploadedFiles.length > 0) {
    //   uploadedFiles.forEach(file => {
    //     formData.append("images", file); // or use "images[]" if your backend expects an array
    //   });
    // }

    if (!testing.soiltype) {
      alert("Soil Type is required.");
      return;
    }
    e.preventDefault();

    try {
      setLoading(prev => ({ ...prev, step1: true }));

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v1/soil_test/start`,
        {
          soiltype: testing.soiltype,
          soil_type: testing.soiltype,
          user_id: 1,
          depth_cm: testing.depthinput,
          latitude: testing.coordinatesX,
          longitude: testing.coordinatesY
        },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );

      if (response.data.status == "success") {
        setCurrTest(prev => ({
          ...prev,
          test_id: response.data.test_id,
          test_status: response.data.test_status,
          current_step: 2
        }));
        setOpenDialog(prev => ({ ...prev, probePlacement: true }));
      }
    } catch (error) {
      console.error("Error uploading:", error);
    } finally {
      setLoading(prev => ({ ...prev, step1: false }));
    }
  };

  const handleUpdateProbePlacement = async () => {
    try {
      setLoading(prev => ({ ...prev, step2: true }));

      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/api/v1/soil_test/${currTest.test_id}/probe`,
        {
          probe_placed: true,
          placement_validated: true
        }
      );
      if (response.data.status == "updated") {
        setCurrTest(prev => ({
          ...prev,
          probe_placed: response.data.probe_placed,
          placement_validated: response.data.placement_validated,
          current_step: 3
        }));
        setOpenDialog(prev => ({ ...prev, probePlacement: false }));
      }
    } catch (error) {
      if (error.response) {
        // Server responded with a status other than 2xx
        console.error("API Error:", error.response.data);
      } else if (error.request) {
        // No response received
        console.error("No response from server:", error.request);
      } else {
        // Something else went wrong
        console.error("Error:", error.message);
      }
    } finally {
      setLoading(prev => ({ ...prev, step2: false }));
    }
  };

  const data = [
    "Clean the probe after each test with distilled water and a soft cloth.",
    "Do not use the sensor in very dry soil — insufficient moisture leads to unreliable ion detection.",
    "Do not bend the sensor during insertion.",
    "Avoid rocky or sandy soils with large particles — these can cause inaccurate readings or damage the probe tip.",
    "Uneven soil mixtures lead to variations in NPK readings.",
    "Mix the soil thoroughly before testing to ensure uniform data.",
    "After mixing the soil, wait for 24 hours before testing — immediate testing can lead to unstable and inaccurate data."
  ];

  return (
    <>
      <Container
        fluid
        className="main-content-container px-4 py-4"
        style={{ backgroundColor: "white", marginleft: "1.75rem" }}
      >
        <Grid Container>
          <Grid item xs={12}>
            <p
              style={{
                color: "rgba(0, 0, 0, 0.80)",
                fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                fontFamily: "Inter, sans-serif",
                fontSize: "1.5rem",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "1.125rem",
                marginTop: "3rem"
              }}
            >
              Start Your Soil Test
            </p>
            <p
              style={{
                color: "rgba(0, 0, 0, 0.80)",
                fontFamily: "Inter, sans-serif",
                fontSize: "1.25rem",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "normal",
                marginBottom: "0.75rem"
              }}
            >
              Check your soil’s health to boost crop growth and efficiency.
            </p>
            <button
              style={{
                display: "flex",
                padding: "1rem 1.5rem",
                justifyContent: "center",
                alignItems: "center",
                gap: "0.25rem",
                borderRadius: "0.5rem",
                border: 0,
                background: "#006BE0"
              }}
              onClick={() => setOpenModal(true)}
            >
              <p
                style={{
                  color: "#FFF",
                  margin: 0,
                  fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                  fontFamily: "Inter, sans-serif",
                  fontSize: "0.875rem",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "1.125rem"
                }}
              >
                Start Soil Testing
              </p>
            </button>
          </Grid>
          <Grid item xs={12}>
            <SoilTestTable />
          </Grid>
          <Grid></Grid>
        </Grid>
      </Container>
      <ReusableModal
        width="97.083vw"
        height="100%"
        open={openModal}
        onClose={() => {
          setTimeLeft(null);
          setTesting({
            soiltype: null,
            coordinatesX: null,
            coordinatesY: null,
            depthinput: null,
            abortReason: null
          });
          setCurrTest({
            test_id: null,
            test_status: null,
            probe_placed: null,
            placement_validated: null,
            current_step: 1,
            timer_started_at: null
          });
          setLoading({
            step1: false,
            step2: false,
            step3: false,
            abort: false
          });
          setOpenModal(false);
        }}
      >
        <Box>
          <Grid container>
            <Grid
              item
              xs={12}
              xl={6}
              lg={6}
              sx={{ background: "#FFFFFF", paddingTop: "1.19rem" }}
            >
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sx={{ paddingBottom: "2.69rem", paddingLeft: "1rem" }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "0.4rem",
                      alignItems: "center",
                      marginTop: "2.38rem"
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M10.8333 6.16732H13.1666V8.50065H10.8333V6.16732ZM12 17.834C12.6416 17.834 13.1666 17.309 13.1666 16.6673V12.0007C13.1666 11.359 12.6416 10.834 12 10.834C11.3583 10.834 10.8333 11.359 10.8333 12.0007V16.6673C10.8333 17.309 11.3583 17.834 12 17.834ZM12 0.333984C5.55998 0.333984 0.333313 5.56065 0.333313 12.0007C0.333313 18.4407 5.55998 23.6673 12 23.6673C18.44 23.6673 23.6666 18.4407 23.6666 12.0007C23.6666 5.56065 18.44 0.333984 12 0.333984ZM12 21.334C6.85498 21.334 2.66665 17.1457 2.66665 12.0007C2.66665 6.85565 6.85498 2.66732 12 2.66732C17.145 2.66732 21.3333 6.85565 21.3333 12.0007C21.3333 17.1457 17.145 21.334 12 21.334Z"
                        fill="black"
                      />
                    </svg>
                    <span
                      style={{
                        color: "rgba(0, 0, 0, 0.80)",
                        margin: 0,
                        fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                        fontFamily: "Inter, sans-serif",
                        fontSize: "1.5rem",
                        fontStyle: "normal",
                        fontWeight: 600,
                        lineHeight: "1.125rem"
                      }}
                    >
                      Soil Testing Instructions & Best Practices
                    </span>
                  </div>
                </Grid>
              </Grid>
              <Grid container>
                <Box
                  sx={{
                    overflowY: "auto",
                    maxHeight: "500px",
                    padding: "1rem",
                    width: "100%" // Ensures full width inside the Grid container
                  }}
                >
                  <Grid item xs={12}>
                    <span
                      style={{
                        color: "#000",
                        fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                        fontFamily: "Inter",
                        fontSize: "1.125rem",
                        fontStyle: "normal",
                        fontWeight: 600,
                        lineHeight: "1.125rem"
                      }}
                    ></span>
                  </Grid>
                  <Grid item xs={12} style={{ marginTop: "1.25rem" }}>
                    <Grid container>
                      <Grid item>
                        <Box
                          sx={{
                            position: "relative",
                            display: "inline-block",
                            overflow: "hidden",
                            maxWidth: "37.6875rem"
                          }}
                        >
                          <ul
                            style={{
                              display: "flex",
                              gap: "0.8rem",
                              flexDirection: "column"
                            }}
                          >
                            {data.map((curr, index) => {
                              return (
                                <li
                                  key={index}
                                  style={{
                                    margin: 0,
                                    padding: 0,
                                    fontSize: 16
                                  }}
                                >
                                  <b>{curr}</b>
                                </li>
                              );
                            })}
                          </ul>
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              xl={6}
              lg={6}
              sx={{ background: "#F9FBFC", paddingTop: "0.87rem" }}
            >
              <Grid container>
                <Grid item xs={12} sx={{ paddingBottom: "3rem" }}>
                  <div
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex"
                    }}
                  >
                    {/* <Typography
                      sx={{
                        color: "rgba(0, 0, 0, 0.80)",
                        fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                        fontFamily: "Inter, sans-serif",
                        fontSize: "1.5rem",
                        fontStyle: "normal",
                        fontWeight: 600,
                        lineHeight: "1.125rem"
                      }}
                    >
                      Soil Test Result
                    </Typography> */}
                  </div>
                </Grid>
              </Grid>
              <Grid container>
                <Box
                  sx={{
                    overflowY: "auto",
                    maxHeight: "500px",
                    padding: "1rem",
                    width: "100%" // Ensures full width inside the Grid container
                  }}
                >
                  <Grid item xs={12} sx={{ marginBottom: "1.12rem" }}>
                    <Typography
                      sx={{
                        color: "#000",
                        fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                        fontFamily: "Inter, sans-serif",
                        fontSize: "1.25rem",
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "1.125rem"
                      }}
                    >
                      Please select Soil Type and Depth-input below{" "}
                      <Typography component="span" sx={{ color: "#FF3B30" }}>
                        *
                      </Typography>
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sx={{ marginBottom: "2.25rem" }}>
                    <Grid container columnGap={2}>
                      <Grid
                        item
                        sx={{
                          display: "flex",
                          maxWidth: "11.875rem",
                          maxHeight: "3rem",
                          padding: "0.625rem 1rem",
                          alignItems: "center",
                          gap: "0.625rem",
                          flexShrink: 0,
                          borderRadius: "0.25rem",
                          border: "1px solid #C0C0C0",
                          background: "#FFF",
                          color: "#555",
                          fontFamily: "Inter",
                          fontSize: "0.875rem",
                          fontStyle: "normal",
                          fontWeight: 400,
                          lineHeight: "1.125rem",
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              border: "none"
                            },
                            "& input": {
                              paddingLeft: "2px"
                            }
                          }
                        }}
                      >
                        <TextField
                          required
                          placeholder="Soil Type"
                          value={testing.soiltype}
                          onChange={e => handleTesting(e, "soiltype")}
                        />
                      </Grid>
                      <Grid
                        item
                        sx={{
                          display: "flex",
                          maxWidth: "11.875rem",
                          maxHeight: "3rem",
                          padding: "0.625rem 1rem",
                          alignItems: "center",
                          gap: "0.625rem",
                          flexShrink: 0,
                          borderRadius: "0.25rem",
                          border: "1px solid #C0C0C0",
                          background: "#FFF",
                          color: "#555",
                          fontFamily: "Inter",
                          fontSize: "0.875rem",
                          fontStyle: "normal",
                          fontWeight: 400,
                          lineHeight: "1.125rem",
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              border: "none"
                            },
                            "& input": {
                              paddingLeft: "2px"
                            }
                          }
                        }}
                      >
                        <TextField
                          placeholder="Depth Input"
                          value={testing.depthinput}
                          onChange={e => handleTesting(e, "depthinput")}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sx={{ marginBottom: "1.12rem" }}>
                    <Typography
                      sx={{
                        color: "#000",
                        fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                        fontFamily: "Inter, sans-serif",
                        fontSize: "1.25rem",
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "1.125rem"
                      }}
                    >
                      Upload Soil image{" "}
                      {/* <Typography component="span" sx={{ color: "#FF3B30" }}>
                        *
                      </Typography> */}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sx={{ marginBottom: "2.25rem" }}>
                    <button
                      style={{
                        display: "flex",
                        padding: "1rem 1.5rem",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "0.5rem",
                        borderRadius: "0.5rem",
                        border: 0,
                        background: "#006BE0"
                      }}
                      onClick={() => fileInputRef.current.click()}
                    >
                      <p
                        style={{
                          color: "#FFF",
                          margin: 0,
                          fontFeatureSettings:
                            "'ss01' on, 'cv01' on, 'cv11' on",
                          fontFamily: "Inter, sans-serif",
                          fontSize: "0.875rem",
                          fontStyle: "normal",
                          fontWeight: 600,
                          lineHeight: "1.125rem"
                        }}
                      >
                        Upload
                      </p>
                    </button>
                    <input
                      type="file"
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      multiple
                      onChange={handleFileUpload}
                    />
                    {uploadedFiles.length > 0 && (
                      <span>{uploadedFiles[0].name}</span>
                    )}
                  </Grid>
                  <Grid item xs={12} sx={{ marginBottom: "1.12rem" }}>
                    <Typography
                      sx={{
                        color: "#000",
                        fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                        fontFamily: "Inter, sans-serif",
                        fontSize: "1.25rem",
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "1.125rem"
                      }}
                    >
                      Please input the GPS coordinates below{" "}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sx={{ marginBottom: "0.87rem" }}>
                    <Grid container columnGap={2}>
                      <Grid
                        item
                        sx={{
                          display: "flex",
                          maxWidth: "11.875rem",
                          maxHeight: "3rem",
                          padding: "0.625rem 1rem",
                          alignItems: "center",
                          gap: "0.625rem",
                          flexShrink: 0,
                          borderRadius: "0.25rem",
                          border: "1px solid #C0C0C0",
                          background: "#FFF",
                          color: "#555",
                          fontFamily: "Inter",
                          fontSize: "0.875rem",
                          fontStyle: "normal",
                          fontWeight: 400,
                          lineHeight: "1.125rem",
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              border: "none"
                            },
                            "& input": {
                              paddingLeft: "2px"
                            }
                          }
                        }}
                      >
                        <TextField
                          placeholder="Latitude"
                          value={testing.coordinatesX}
                          onChange={e => handleTesting(e, "coordinatesX")}
                        />
                      </Grid>
                      <Grid
                        item
                        sx={{
                          display: "flex",
                          maxWidth: "11.875rem",
                          maxHeight: "3rem",
                          padding: "0.625rem 1rem",
                          alignItems: "center",
                          gap: "0.625rem",
                          flexShrink: 0,
                          borderRadius: "0.25rem",
                          border: "1px solid #C0C0C0",
                          background: "#FFF",
                          color: "#555",
                          fontFamily: "Inter",
                          fontSize: "0.875rem",
                          fontStyle: "normal",
                          fontWeight: 400,
                          lineHeight: "1.125rem",
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              border: "none"
                            },
                            "& input": {
                              paddingLeft: "2px"
                            }
                          }
                        }}
                      >
                        <TextField
                          placeholder="Longitude"
                          value={testing.coordinatesY}
                          onChange={e => handleTesting(e, "coordinatesY")}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sx={{ marginBottom: "1.12rem" }}>
                    {timeLeft == 0 ? (
                      <>
                        <Grid container gap={0.8}>
                          {smallStat.map((stats, idx) => (
                            <Grid item xs={12} sm={6} md={6} lg={3} key={idx}>
                              <SmallStats
                                id={`small-stats-${idx}`}
                                variation="1"
                                chartData={stats.datasets}
                                chartLabels={stats.chartLabels}
                                label={stats.label}
                                units={stats.units}
                                value={stats.value}
                                ts={stats.ts}
                                img={stats.img}
                                percentage={stats.percentage}
                                increase={stats.increase}
                                decrease={stats.decrease}
                              />{" "}
                            </Grid>
                          ))}{" "}
                        </Grid>
                      </>
                    ) : currTest.test_status == "running" ? (
                      <div
                        style={{
                          marginTop: "2.25rem",
                          gap: "2.5rem",
                          borderRadius: "0.5rem",
                          border: "1px solid rgba(0, 0, 0, 0.10)",
                          background: "#FFF",
                          maxWidth: "22.4375rem",
                          maxHeight: "9.4375rem",
                          display: "flex",
                          flexDirection: "column",
                          padding: "1.5rem",
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "1.62rem",
                            alignItems: "center",
                            justifyContent: "center"
                          }}
                        >
                          <div>
                            <p
                              style={{
                                margin: 0,
                                fontSize:
                                  currTest.retry == true ? "1.25rem" : "2rem",
                                textAlign: "center",
                                color:
                                  currTest.retry == true ? "#D32F2F" : "#040404"
                              }}
                            >
                              {" "}
                              {currTest.retry == true
                                ? "ERROR"
                                : formatTime(timeLeft)}
                            </p>
                          </div>
                          <div>
                            <button
                              style={{
                                display: "inline-flex",
                                padding: "0.625rem 1.5rem",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "0.625rem",
                                borderRadius: "0.5rem",
                                border: "1px solid #D32F2F",
                                background: "#FFF"
                              }}
                              onClick={
                                currTest.retry == true
                                  ? handleProceedStartTest
                                  : () =>
                                      setOpenDialog(prev => ({
                                        ...prev,
                                        AbortTimer: true
                                      }))
                              }
                            >
                              <p
                                style={{
                                  color: "#D32F2F",
                                  margin: 0,
                                  fontFeatureSettings:
                                    "'ss01' on, 'cv01' on, 'cv11' on",
                                  fontFamily: "Inter, sans-serif",
                                  fontSize: "0.875rem",
                                  fontStyle: "normal",
                                  fontWeight: 600,
                                  lineHeight: "1.125rem"
                                }}
                              >
                                {currTest.retry == true ? (
                                  loading.step3 == true ? (
                                    <CircularProgress
                                      sx={{ color: "#D32F2F" }}
                                      size={14}
                                    />
                                  ) : (
                                    "Retry"
                                  )
                                ) : (
                                  "Cancel"
                                )}
                              </p>
                            </button>
                          </div>
                        </div>
                        <div>
                          <p
                            style={{
                              margin: 0,
                              color: "#D32F2F",
                              fontFamily: "Inter, sans-serif",
                              fontSize: "0.75rem",
                              fontStyle: "italic",
                              fontWeight: 400,
                              lineHeight: "1.125rem"
                            }}
                          >
                            {currTest.retry == true
                              ? currTest.retryMessage
                              : "Please wait for 10 mins for the testing to be completed"}
                          </p>
                        </div>
                      </div>
                    ) : (
                      <button
                        style={{
                          display: "flex",
                          padding: "0.625rem 1.5rem",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "0.625rem",
                          borderRadius: "0.5rem",
                          border: 0,
                          background:
                            currTest.current_step == 3 ? "#006BE0" : "#2E7D32"
                        }}
                        onClick={
                          currTest.current_step == 3
                            ? handleProceedStartTest
                            : handleProceedTest
                        }
                      >
                        <p
                          style={{
                            color: "#FFF",
                            margin: 0,
                            fontFeatureSettings:
                              "'ss01' on, 'cv01' on, 'cv11' on",
                            fontFamily: "Inter, sans-serif",
                            fontSize: "0.875rem",
                            fontStyle: "normal",
                            fontWeight: 600,
                            lineHeight: "1.125rem"
                          }}
                        >
                          {loading["step1"] == true ||
                          loading["step3"] == true ? (
                            <CircularProgress
                              sx={{ color: "#FFF" }}
                              size={26}
                            />
                          ) : currTest.current_step == 3 ? (
                            "Start Test"
                          ) : (
                            "Proceed"
                          )}
                        </p>
                      </button>
                    )}
                  </Grid>

                  {/* <Grid item xs={12} sx={{ marginBottom: "1.12rem" }}>
                    <Typography
                      sx={{
                        color: "#000",
                        fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                        fontFamily: "Inter, sans-serif",
                        fontSize: "1.25rem",
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "1.125rem"
                      }}
                    >
                      Place the sensor probe in the soil and press
                      Confirm/Cancel button below{" "}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} >
                    <Grid container columnGap={2}>
                      <Grid item>
                        <button
                          style={{
                            display: "flex",
                            padding: "0.625rem 1.5rem",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "0.625rem",
                            borderRadius: "0.5rem",
                            border: 0,
                            background: "#2E7D32"
                          }}
                        >
                          <p
                            style={{
                              color: "#FFF",
                              margin: 0,
                              fontFeatureSettings:
                                "'ss01' on, 'cv01' on, 'cv11' on",
                              fontFamily: "Inter, sans-serif",
                              fontSize: "0.875rem",
                              fontStyle: "normal",
                              fontWeight: 600,
                              lineHeight: "1.125rem"
                            }}
                          >
                            Confirm
                          </p>
                        </button>
                      </Grid>
                      <Grid item>
                        <button
                          style={{
                            display: "inline-flex",
                            padding: "0.625rem 1.5rem",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "0.625rem",
                            borderRadius: "0.5rem",
                            border: "1px solid #D32F2F",
                            background: "#FFF"
                          }}
                        >
                          <p
                            style={{
                              color: "#D32F2F",
                              margin: 0,
                              fontFeatureSettings:
                                "'ss01' on, 'cv01' on, 'cv11' on",
                              fontFamily: "Inter, sans-serif",
                              fontSize: "0.875rem",
                              fontStyle: "normal",
                              fontWeight: 600,
                              lineHeight: "1.125rem"
                            }}
                          >
                            Cancel
                          </p>
                        </button>
                      </Grid>
                    </Grid>
                  </Grid> */}
                </Box>
              </Grid>
            </Grid>
            {timeLeft == 0 && currTest.test_status == "complete" && (
              <Grid container style={{ paddingTop: "1rem" }}>
                <Grid
                  item
                  xs={12}
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <button
                    style={{
                      display: "flex",
                      padding: "1rem 1.5rem",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "0.25rem",
                      borderRadius: "0.5rem",
                      textTransform: "none",
                      marginRight: "1.5rem",
                      backgroundColor: "#006BE0",
                      fontFamily: "Inter, sans-serif",
                      border: 0,
                      whiteSpace: "none",
                      color: "#FFF",
                      fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                      fontSize: "0.875rem",
                      fontStyle: "normal",
                      fontWeight: 600,
                      lineHeight: "1.125rem"
                    }}
                    onClick={handleStartNewTest}
                  >
                    Start New Test
                  </button>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Box>
      </ReusableModal>
      <ControlledDialog
        open={openDialog.probePlacement}
        onClose={() =>
          setOpenDialog(prev => ({ ...prev, probePlacement: false }))
        }
        onConfirm={handleUpdateProbePlacement}
        title="Place the sensor probe in the soil and press Confirm/Cancel button below"
        content=""
        actions={({ close, handleAgree }) => (
          <>
            <button
              style={{
                display: "inline-flex",
                padding: "0.625rem 1.5rem",
                justifyContent: "center",
                alignItems: "center",
                gap: "0.625rem",
                borderRadius: "0.5rem",
                border: "1px solid #D32F2F",
                background: "#FFF"
              }}
              onClick={close}
            >
              <p
                style={{
                  color: "#D32F2F",
                  margin: 0,
                  fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                  fontFamily: "Inter, sans-serif",
                  fontSize: "0.875rem",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "1.125rem"
                }}
              >
                Cancel
              </p>
            </button>
            <button
              style={{
                display: "flex",
                padding: "0.625rem 1.5rem",
                justifyContent: "center",
                alignItems: "center",
                gap: "0.625rem",
                borderRadius: "0.5rem",
                border: 0,
                background: "#2E7D32"
              }}
              onClick={handleAgree}
            >
              <p
                style={{
                  color: "#FFF",
                  margin: 0,
                  fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                  fontFamily: "Inter, sans-serif",
                  fontSize: "0.875rem",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "1.125rem"
                }}
              >
                {loading.step2 ? (
                  <CircularProgress sx={{ color: "#FFF" }} size={26} />
                ) : (
                  "Confirm"
                )}
              </p>
            </button>
          </>
        )}
      />
      <ControlledDialog
        open={openDialog.AbortTimer}
        onClose={() => setOpenDialog(prev => ({ ...prev, AbortTimer: false }))}
        onConfirm={handleAbortTimer}
        title="Are you sure you want to Cancel ?"
        content={
          <div style={{ marginTop: "1rem" }}>
            <label
              htmlFor="cancel-reason"
              style={{
                display: "block",
                marginBottom: "0.5rem",
                fontFamily: "Inter, sans-serif",
                fontSize: "0.875rem",
                fontWeight: 500
              }}
            >
              Please provide a reason:
            </label>
            <input
              id="cancel-reason"
              type="text"
              value={testing.abortReason}
              onChange={e => handleTesting(e, "abortReason")}
              placeholder="Enter reason here..."
              style={{
                width: "100%",
                padding: "0.5rem",
                fontSize: "0.875rem",
                borderRadius: "0.375rem",
                border: "1px solid #ccc",
                fontFamily: "Inter, sans-serif"
              }}
            />
          </div>
        }
        actions={({ close, handleAgree }) => (
          <>
            <button
              style={{
                display: "inline-flex",
                padding: "0.625rem 1.5rem",
                justifyContent: "center",
                alignItems: "center",
                gap: "0.625rem",
                borderRadius: "0.5rem",
                border: "1px solid #D32F2F",
                background: "#FFF"
              }}
              onClick={close}
            >
              <p
                style={{
                  color: "#D32F2F",
                  margin: 0,
                  fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                  fontFamily: "Inter, sans-serif",
                  fontSize: "0.875rem",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "1.125rem"
                }}
              >
                Cancel
              </p>
            </button>
            <button
              style={{
                display: "flex",
                padding: "0.625rem 1.5rem",
                justifyContent: "center",
                alignItems: "center",
                gap: "0.625rem",
                borderRadius: "0.5rem",
                border: 0,
                background: "#2E7D32"
              }}
              onClick={handleAgree}
            >
              <p
                style={{
                  color: "#FFF",
                  margin: 0,
                  fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                  fontFamily: "Inter, sans-serif",
                  fontSize: "0.875rem",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "1.125rem"
                }}
              >
                {loading.abort ? (
                  <CircularProgress sx={{ color: "#FFF" }} size={26} />
                ) : (
                  "Agree"
                )}
              </p>
            </button>
          </>
        )}
      />
    </>
  );
};

export default SoilTesting;
